import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule, MatCheckboxModule, MatFormFieldModule, MatIconModule, MatInputModule } from '@angular/material';
import { FuseSharedModule } from '@fuse/shared.module';
import { FLTLoginComponent } from 'app/main/fltlogin/fltlogin.component';
import { OktaAuthModule, OktaCallbackComponent } from '@okta/okta-angular';
import { Security } from 'app/model/security.model';

const security = new Security();
const config = {
    url: security.OktaURL,
    issuer: security.OktaIssuer,
    redirectUri: security.OktaRedirectURL,
    clientId: security.OktaClientId
  
}


const routes = [
    {
        path: '',
        component: FLTLoginComponent
    }
];

@NgModule({
    declarations: [
        FLTLoginComponent
    ],
    imports: [
        RouterModule.forChild(routes),

        //FLTLoginComponent,

        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,

        FuseSharedModule,
        OktaAuthModule.initAuth(config)
    ]
})
export class FLTLoginModule {
}
